// Active Reveal
$('.active_click').click(function() {
  $(this).closest('.active_wrap').toggleClass('active');
   console.log('active_click click');
});

// Quanthold
var quant_input;
$('.quanthold').click(function() {
  quant_input = $(this).find('.quant_input');
  if ( quant_input.length > 0 ) {
    $(quant_input).select();
  } 
});


// Side Menu

$('#menu_button, #mob_menu .icon-menu').click(function(){
  $('body').addClass("menu_active");
});

$('#mob_menu .icon-close, #close_menu').click(function(){
  $('body').removeClass("menu_active");
});


$('#nav_return').click(function(){
  $('#nav_page').attr("data-filter", "none" );
  $('.motherlink').removeClass("active");
  // New code
  $('.menu_subsection').removeClass("active");
  $('#nav_left').removeClass("hidden");
});

$('.motherlink').click(function(){
  var click_id = $(this).attr("data-addFilter");
  $('.menu_subsection').removeClass("active");
  $('.menu_subsection').filter('.filter_' + click_id).addClass("active");
  $('#nav_left').addClass("hidden");
});

// Solves issue where page was not loading if clicked href matched current url
$('.menu_sublinks > a').click(function(){
  // Removes hashes from current url and link to do comparison
  var nowurl = window.location.pathname.split("#")[0];
  var clickurl = $(this).attr('href').split('#')[0];
  // If they match then load the click href with hash
  if ( nowurl == clickurl ) {
    window.location = $(this).attr('href');
    window.location.reload();
  }
});

// Sidecart

// $('#cart_icon').click(function() {
//   event.preventDefault();
//   if ($('#header_sidecart').hasClass("open")) $('#header_sidecart').removeClass('open');
//   else $('#header_sidecart').addClass('open');
// });

// $('#header_sidecart .drawer_close').click(function() {
//   $('#header_sidecart').removeClass('open');
// });

// $( document ).ready(function() {
//   window.addEventListener('scroll', function(){
//     if (window.pageYOffset > 50) $('body').addClass("has_scrolled");
//     else $('body').removeClass("has_scrolled");
//   });
// });

// $(document).on("click", function(event){
//   if( $('#header_sidecart').hasClass("open") && !$(event.target).closest("#header_sidecart").length && !$(event.target).closest("#cart_icon").length){
//     $('#header_sidecart').removeClass('open');
//   }
//   if( $('body').hasClass("menu_active") && !$(event.target).closest("#mob_menu").length && !$(event.target).closest("#nav_page").length && !$(event.target).closest("#menu_button").length){
//     console.log($('body').attr("class"));
//     $('body').removeClass("menu_active");
//   }
// });

// Search Function

$('#menu_search, #header_search').click(function() {
  if ( $('body').hasClass("search_active") ) { console.log("Search active already");}
  else {
    $('body').addClass("search_active");
    $('#menusearch_form_wrap').addClass("active");
    $('#menusearch_input').focus();
  }
});

$('#searchpage_close').click(function() {
  $('body').removeClass("search_active");
  $('#menusearch_form_wrap').removeClass("active");
});

// Dropdown functions

$( document ).ready(function() {
  $('.drop_item').click(function(){
    var wrapper = $(this).parent().parent();
    if ( $(wrapper).hasClass("active") ) {
      if ( $(this).hasClass("active") == false ) {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
      }
      $(wrapper).removeClass("active");
    }
    else $(wrapper).addClass("active");
  });
});


$( document ).ready(function() {
  $('#giftcard_options .drop_item').click(function(){
    var data_option = $(this).data('option');
    $('#giftcard_option').attr("value", data_option);
  });
  $('#giftcard_amount .drop_item').click(function(){
    var var_id = $(this).data('var_id');
    $('#giftcard_var').attr("value", var_id);
    // Additional styling to fix overlap issue
    $('#giftcard_options').toggleClass('inactive');
  });
});
